import { isAnimationControls } from './basler-components.es887.js';
import { isVariantLabel } from './basler-components.es888.js';
import { variantProps } from './basler-components.es889.js';

function isControllingVariants(props) {
    return (isAnimationControls(props.animate) ||
        variantProps.some((name) => isVariantLabel(props[name])));
}
function isVariantNode(props) {
    return Boolean(isControllingVariants(props) || props.variants);
}

export { isControllingVariants, isVariantNode };
